module.exports = __webpack_public_path__ + "img/sebastian-hagens-4.aa3f64b7.jpg";